import { useJSONConfig } from '@sky-tv-group/shared';
import cx from 'classnames';
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { AppRoutes } from '../constants';
import { configService } from '../services';

const SubMenu = () => {
  let location = useLocation();
  let config = useJSONConfig(configService);
  let menus: { name: string; link: string }[] = config?.broadband?.acquisition?.subMenu ?? [];
  // only show on home page
  if (
    location.pathname !== AppRoutes.Home &&
    location.pathname !== AppRoutes.NetworkStatus &&
    location.pathname !== AppRoutes.Setup &&
    location.pathname !== AppRoutes.Offers
  )
    return null;

  return (
    <div className="m-auto overflow-x-auto sticky sky-bg-gray-light top-4 z-30 shadow-md ">
      <nav className="flex justify-start md:justify-center text-primary-mid-night">
        {menus.map((menu, index) => {
          let menuPath;
          if (menu.name === 'Home') {
            menuPath = '/';
          } else {
            menuPath = new URL(menu.link).pathname;
          }
          let isExternal = false;
          if (menu.name === 'Support') {
            isExternal = true;
          }
          let selected = index === 0;
          if (location.pathname !== '/') {
            selected = menu.link.includes(location.pathname);
          }
          let cls = cx(' sky-h4 md:sky-h7 font-medium  whitespace-wrap hover:sky-blue-primary', {
            'text-primary-day-light border-b-2 border-blue-light': selected,
          });
          return (
            <div className="md:pl-5 2xl:pl-3 p-2 px-8" key={index}>
              {isExternal ? (
                <a href={menu.link} className={cls} target="_self" rel="noopener noreferrer">
                  {menu.name}
                </a>
              ) : (
                <Link to={menuPath} className={cls}>
                  {menu.name}
                </Link>
              )}
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export { SubMenu };
